import type { PerformanceCoreDatapoint, PerformanceDatapoint } from "owa-analytics";
import { DatapointStatus } from "owa-analytics-types";

type SearchEndToEndDatapoint = PerformanceDatapoint | PerformanceCoreDatapoint;

let inFlightDatapoint: SearchEndToEndDatapoint | undefined;

/**
 * Tracks the latest mail SearchEndToEnd datapoint. If a previous one is still in flight
 * and has no outcome stamped, it is ended as Abandoned/UserCancelled so it is not later
 * reported as a 60s Timeout.
 */
export default function trackSearchEndToEndDatapoint(datapoint: SearchEndToEndDatapoint): void {
    const previous = inFlightDatapoint;
    inFlightDatapoint = datapoint;
    
    if (!previous ||
        previous === datapoint ||
        previous.isSent() ||
        previous.hasCustomData("searchOutcome")) {
        return;
    }
    
    previous.addCustomData({ searchOutcome: "Abandoned", abandonReason: "Superseded" });
    previous.end(undefined /* duration */, DatapointStatus.UserCancelled);
}

export function resetTrackedSearchEndToEndDatapointForTest(): void {
    inFlightDatapoint = undefined;
}
